module.exports = __webpack_public_path__ + "static/media/lcg-shape-dark-blue.65bdd06b.svg";